import { ID_INJECTION_KEY, ZINDEX_INJECTION_KEY } from 'element-plus';
import { type App as VueApp } from 'vue';
export const ElementPlusPlugin = {
  install(app: VueApp) {
    // Provide z-index context
    app.provide(ZINDEX_INJECTION_KEY, { current: 0 });

    // Provide ID injection context
    app.provide(ID_INJECTION_KEY, {
      prefix: 1000,
      current: 0,
    });
  },
};
